import { render, staticRenderFns } from "./account_settings.vue?vue&type=template&id=ada6b4a2&scoped=true&"
import script from "./account_settings.vue?vue&type=script&lang=js&"
export * from "./account_settings.vue?vue&type=script&lang=js&"
import style0 from "./account_settings.vue?vue&type=style&index=0&id=ada6b4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada6b4a2",
  null
  
)

export default component.exports